"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Disclaimers_meta_1 = require("../Disclaimers.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('section', Disclaimers_meta_1.DISCLAIMERS_CATEGORY_KEY, Disclaimers_meta_1.DISCLAIMERS_COMPONENT_KEY, ['wrapper']);